/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import OfferingRepository from 'repositories/loanOfficer/OfferingRepository';

const initialState = {
  loading: false,
  offerings: [],
};

const offeringsSlice = createSlice({
  name: 'offeringsSlice',
  initialState,
  reducers: {
    loadOfferingsStart(state) {
      state.loading = true;
    },
    loadOfferingsSuccess(state, { payload }) {
      const { data } = payload;
      state.offerings = data.map(({ id, attributes: { name } }) => ({ id, name }));
      state.loading = false;
    },
    loadOfferingsFail(state) {
      state.loading = false;
    },
  },
});

export const { actions } = offeringsSlice;

export default offeringsSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const loadOfferings = async () => {
    dispatch(actions.loadOfferingsStart());
    try {
      const response = await OfferingRepository.index();
      dispatch(actions.loadOfferingsSuccess(response));
    } catch (_error) {
      dispatch(actions.loadOfferingsFail());
    }
  };

  return {
    loadOfferings,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/offeringsSlice.js